<template>
  <div class="navbar flex justify-between items-center h-68 pl-12 pr-10 box-sizing">
    <div class="navbar-left flex items-center">
      <div class="logo flex items-center gap-8">
        <img src="@/assets/logo_all.png" alt="logo" class="w-336 h-44" />
      </div>
    </div>
    <div class="navbar-right flex items-center gap-16">
        <div>
            <el-dropdown @command="handleCommand" trigger="click">
                <div class="cursor-pointer el-dropdown-link">
                  <img src="@/assets/logo_person.png" alt="avatar" class="w-40 h-40" />
                </div>
                <el-dropdown-menu slot="dropdown" class="user-dropdown">
                    <!-- 用户信息区域 -->
                    <div class="flex flex-col px-18 border-b py-16 color-text font-semibold">
                      <div class="user-name text-14 mb-12">{{ userModel.redisUserName || '' }}</div>
                      <div class="user-id text-12">{{ userModel.redisUserPhone || '' }}</div>
                    </div>
                    <!-- 菜单选项 -->
                    <div class="flex items-center gap-10 py-14 px-18 cursor-pointer text-14 person-item" @click="handleCommand('changePassword')">
                        <i class="el-icon-lock"></i>
                        <span>修改密码</span>
                    </div>
                    <div class="flex items-center gap-10 py-14 px-18 cursor-pointer text-14 person-item" @click="handleCommand('logout')">
                        <i class="el-icon-switch-button"></i>
                        <span>退出登录</span>
                    </div>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
		<div>
		</div>
        <div v-if="hasPendingTasks">
          <!-- 有代办数据时显示下拉框 -->
          <el-dropdown trigger="click">
            <div class="cursor-pointer el-dropdown-link">
              <el-badge :value="totalPendingCount" :max="9" class="item system-news-count-badge">
                <i class="el-icon-bell text-white text-20"></i>
              </el-badge>
            </div>
            <el-dropdown-menu slot="dropdown" class="pending-task-dropdown">
              <div 
                v-for="(item, index) in pendingTaskList" 
                :key="index"
                class="flex items-center justify-between px-18 py-12 cursor-pointer person-item"
                @click="handleTaskClick(item)"
              >
                <span class="text-14">{{ item.dataType }}</span>
                <div class="system-news-count">{{ item.count }}</div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="navbar-tools flex gap-28">
            <el-tooltip content="帮助" placement="bottom">
                <img src="@/assets/helppic.png" alt="help" class="w-16 h-16 cursor-pointer" @click="showHelpDialog" />
            </el-tooltip>
            <el-tooltip :content="isFullscreen ? '退出全屏' : '全屏'" placement="bottom">
              <div class="fullscreen-btn w-16 h-16 cursor-pointer flex items-center justify-center" @click="toggleFullscreen">
                <img 
                  :src="isFullscreen ? require('@/assets/exit_fullscreen.png') : require('@/assets/fullscreen.png')" 
                  :alt="isFullscreen ? 'exit' : 'full'" 
                  class="w-16 h-16" 
                />
              </div>
            </el-tooltip>
        </div>      
    </div>
    
    <!-- 帮助搜索对话框组件 -->
    <HelpDialog 
      :visible.sync="helpDialogVisible"
      :menu-id="currentMenuId"
      @search="handleHelpSearch"
      @close="handleHelpClose"
    />
  </div>
</template>

<script>
import HelpDialog from '@/components/common/HelpDialog.vue'
import { commonApi } from '@/api'
import { sk } from '@/config'
export default {
  name: 'AppHeader',
  components: {
    HelpDialog
  },
  props: {
    activeMenu: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      switchVisible: false,
      hoverKey: '',
      userModel: {},
      isFullscreen: false,
      helpDialogVisible: false,
      hidden: true,
      msgList: [],
      systemNewsCount: 0,
      pendingTaskList: [],
      systemNewsTimer: null // 系统消息定时器
    }
  },
  computed: {
    currentMenuId() {
      return this.activeMenu
    },
    // 计算是否有代办任务（至少有一项数量 > 0）
    hasPendingTasks() {
      return Array.isArray(this.pendingTaskList) && this.pendingTaskList.some(t => Number(t.count) > 0)
    },
    // 计算代办任务总数
    totalPendingCount() {
      return this.pendingTaskList.reduce((total, task) => total + (task.count || 0), 0)
    }
  },
  created() {
    this.initUserModel()
    this.startSystemNewsTimer()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.systemNewsTimer) {
      clearInterval(this.systemNewsTimer)
      this.systemNewsTimer = null
    }
  },
  methods: {
    // 获取系统消息
    getSystemNews() {
      commonApi.getMsg().then(res => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            const newData = res.data
            const hasChanged = JSON.stringify(newData) !== JSON.stringify(this.pendingTaskList)
            if (hasChanged) {
              this.pendingTaskList = newData
            }
          } else {
            // 只有当当前有数据时才清空，避免重复清空
            if (this.pendingTaskList.length > 0) {
              this.pendingTaskList = []
            }
          }
        }
      }).catch(error => {
        if (this.pendingTaskList.length > 0) {
          this.pendingTaskList = []
        }
      })
    },
    // 处理代办任务点击
    handleTaskClick(item) {
      if (item.goUrl) {
        // 通过事件总线通知Layout组件处理菜单tab
        this.$bus.$emit('pending-task-click', {
          goUrl: item.goUrl,
          dataType: item.dataType,
          count: item.count
        })
        
        // 直接路由跳转
        this.$router.push(item.goUrl).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
          }
        })
      }
    },
    // 初始化用户模型数据
    initUserModel() {
      try {
        const userModelStr = localStorage.getItem(sk('user_model'))
        if (userModelStr) {
          this.userModel = JSON.parse(userModelStr)
        }
      } catch (error) {
        this.userModel = {}
      }
    },

    // 选择系统
    selectSystem(key) {
      this.switchVisible = false
      this.$emit('switch-system')
      this.$emit('system-select', key)
    },

    // 全屏切换
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen
      this.$emit('toggle-fullscreen')
    },

    // 刷新页面
    refreshPage() {
      this.$emit('refresh-page')
    },

    // 处理用户下拉菜单
    handleCommand(command) {
      this.$emit('user-command', command)
    },

    // 显示帮助对话框
    showHelpDialog() {
      this.helpDialogVisible = true
    },

    // 处理帮助搜索
    handleHelpSearch(query) {
      // 这里可以添加实际的搜索逻辑
      this.$message.info(`搜索: ${query}`)
    },

    // 处理帮助对话框关闭
    handleHelpClose() {
    },

    // 启动系统消息定时器
    startSystemNewsTimer() {
      if (this.systemNewsTimer) {
        clearInterval(this.systemNewsTimer)
      }
      // 立即执行一次请求
      this.getSystemNews()
      // 设置30秒定时器
      this.systemNewsTimer = setInterval(() => {
        this.getSystemNews()
      }, 30000) // 30秒 = 30000毫秒
    }
  }
}
</script>

<style scoped>
.navbar {
  background: linear-gradient(90deg, rgba(17, 91, 250, 1) 0%, rgba(62, 173, 247, 1) 100%);
}
/* 用户下拉菜单样式 */
.user-dropdown {
  padding: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
}
.pending-task-dropdown {
  padding: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
}
/* 全屏按钮样式 */
.fullscreen-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.fullscreen-btn:hover {
    transform: scale(1.1);
}
.fullscreen-btn img {
  display: block;
  max-width: 100%;
  height: auto;
}
.person-item:hover{
  background: rgba(245, 247, 249, 1);
}
/* 穿透 scoped，覆盖 Element UI 内部徽标样式 */
.system-news-count-badge /deep/ .el-badge__content,
.system-news-count-badge ::v-deep .el-badge__content{
  line-height: 14px !important;
  border: 1px solid #F56C6C !important;
}
.system-news-count{
  background: #F56C6C;
  color: white;
  padding: 0px 6px;
  line-height: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 12px;
}
</style>
<style>
/* 系统切换 Popover 样式（非 scoped，作用于 popper） */
.system-switcher-popper {
  width: 224px;
  height: 152px;
  opacity: 1;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 6px  rgba(0, 0, 0, 0.12);
}
.system-switcher-popper .sys-card.active, .system-switcher-popper .sys-card:hover {
  background: rgba(245, 247, 249, 1);
}
.system-switcher-popper .sys-card .meta .desc {
  color: rgba(144, 147, 153, 1);
}

</style>